import { render, staticRenderFns } from "./reg_header.vue?vue&type=template&id=1c217eb1&scoped=true"
import script from "./reg_header.vue?vue&type=script&lang=js"
export * from "./reg_header.vue?vue&type=script&lang=js"
import style0 from "./reg_header.vue?vue&type=style&index=0&id=1c217eb1&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c217eb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c217eb1')) {
      api.createRecord('1c217eb1', component.options)
    } else {
      api.reload('1c217eb1', component.options)
    }
    module.hot.accept("./reg_header.vue?vue&type=template&id=1c217eb1&scoped=true", function () {
      api.rerender('1c217eb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/landingpage/reg_header.vue"
export default component.exports